
// 校验文件类型
export function verifyType(name, accept) {
  const suffix = name.split(".").at(-1);
  if (!accept.includes(suffix.toLowerCase())) {
    throw new Error(`请上传${accept}格式的文件！`)
  }
}

// 校验文件大小
export function verifySize(fileSize, size, fileTypeText) {
  if (fileSize / 1024 > size) {
    let { newSize, unit } = unitConversion(size)
    throw new Error(`${fileTypeText}大小不能超过${newSize}${unit}`)
  }
}
// 单位转换
function unitConversion(size) {
  if (size > 1024) {
    return {
      newSize: size / 1024,
      unit: 'MB'
    }
  }
  return {
    newSize: size,
    unit: 'KB'
  }
}
// 校验文件宽高比
export async function verifyRatio(fileInfo, ratio) {
  if (!ratio) return fileInfo
  let ratioArr = ratio.split(':')
  let ratioWidth = Number(ratioArr[0])
  let ratioHeight = Number(ratioArr[1])
  if (!ratioWidth || !ratioHeight) return fileInfo
  const { width, height } = await getImageDetail(fileInfo)
  if (width / height !== ratioWidth / ratioHeight) {
    throw new Error(`请上传宽高比为${ratio}大小的文件！`)
  }
}

function getImageDetail(fileInfo){
  const img = new Image();
  img.src = URL.createObjectURL(fileInfo); // url地址 url跟 视频流是一样的
  return new Promise((resolve) => {
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
        img
      });
      URL.revokeObjectURL(img.src); // 释放URL对象引用
    };
  });
}



// 压缩图片函数，接收一个文件和压缩质量参数
export function compressImg(file) {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    // 如果图片大小小于500KB，直接返回原始图片数据
    if (file.size < 500 * 1024) {
      resolve({
        file: file
      })
    } else {
      let { img: image, width, height } = await getImageDetail(file)
      // 创建一个新的画布元素和上下文，用于绘制压缩后的图片
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      if (!context) return reject('压缩失败')
      // 计算目标图片的宽度和高度，以适应最大宽度和高度的要求
      var targetWidth = width
      var targetHeight = height
      var maxWidth = 800
      var maxHeight = 800
      // 缩放图片尺寸以适应最大宽度和高度
      if (targetWidth > maxWidth || targetHeight > maxHeight) {
        const scaleFactor = Math.min(maxWidth / targetWidth, maxHeight / targetHeight);
        targetWidth *= scaleFactor;
        targetHeight *= scaleFactor;
      }
      // 设置画布的尺寸
      canvas.width = targetWidth
      canvas.height = targetHeight
      // 清空画布并在画布上绘制压缩后的图片
      context.clearRect(0, 0, targetWidth, targetHeight)
      context.drawImage(image, 0, 0, targetWidth, targetHeight)
      // 将压缩后的图片数据转换为 data URI。可以使用 type 参数其类型，默认为 PNG 格式。qualitys越小，文件体积越小
      // 1是压缩质量qualitys可使用该变量调节压缩大小
      const canvasURL = canvas.toDataURL(file.type, 1)
      // 解码 data URI，获取图片的二进制数据。atob：是ascii to binary，用于将ascii码解析成binary数据，即Base64的解码过程。
      const buffer = atob(canvasURL.split(',')[1])
      let length = buffer.length
      //创建一个 Uint8Array 类型的向量，用于存储图片的二进制数据
      const bufferArray = new Uint8Array(new ArrayBuffer(length))
      while (length--) {
        bufferArray[length] = buffer.charCodeAt(length)
      }
      // 创建一个压缩后的文件对象
      const miniFile = new File([bufferArray], file.name, {
        type: file.type,
      })

      // 解析压缩后的文件对象
      resolve({
        file: miniFile,
        origin: file,
        beforeSize: file.size,
        afterSize: miniFile.size
      })
    }
  })
}